<template>
    <div class="col-md-9">
        <h1 class="pages__title">Edit home</h1>
        <div class="pages__box">
            <div class="form">
                <div>
                    <h2 class="profile__title">General</h2>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Page</label>
                        <input type="text"  class="form-control pl-4" v-model="listOfFields.name">
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Route</label>
                        <input type="text" class="form-control pl-4" v-model="listOfFields.route">
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Title</label>
                        <input type="text" class="form-control pl-4" v-model="listOfFields.title">
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Meta Title</label>
                        <input type="text" class="form-control pl-4" v-model="listOfFields.meta_title">
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Meta Description</label>
                        <input type="text" class="form-control pl-4" v-model="listOfFields.meta_description">
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Meta Description Novelty</label>
                        <input type="text" class="form-control" v-model="listOfFields.meta_keywords">
                    </div>
                    <div class="form-group mb-3">
                        <div class="d-flex align-items-center">
                            <label for="" class="form-label mb-0 mr-3">Active</label>
                            <div class="switcher">
                                <input
                                    type="checkbox"
                                    v-model="listOfFields.is_active"
                                >
                                <div class="box">
                                    <span class="bar"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <h2 class="profile__title">General</h2>
                    <form>
                        <div
                            v-for="(field, key) in listOfFields.content"
                            :key="key"
                            class="mb-4"
                        >
                            <label class="form-label">{{ formatLabel(key) }}</label>

                            <DynamicField
                                :page-id="pageId"
                                :field="field"
                                :field-name="key"
                                @update-content="updateContent"
                            />
                        </div>

                    </form>
                </div>
            </div>
            <BaseButtons
                :on-cancel="backToPreviousPage"
                :on-save="updatePage"
            />
        </div>

    </div>
</template>

<script>
import AdminPanelService from "../../../services/AdminPanelService";
import ImageGalleryWithTitles from "../../Common/ContentFields/ImageGalleryWithTitles.vue";
import DynamicField from "../../Common/ContentFields/DynamicField.vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import ModalHandler from "../../../mixins/ModalHandler";

export default {
    name: 'PageEditor',
    mixins: [ModalHandler],
    components: {BaseButtons, DynamicField, ImageGalleryWithTitles},
    props: {
        pageId: Number,
    },
    data() {
        return {
            listOfFields: {
                name: null,
                route: null,
                title: null,
                is_active: null,
                id: null,
                meta_description: null,
                meta_keywords: null,
                meta_title: null,
                content: {}
            },
            updatedContent: {}
        }
    },
    methods: {
        updateContent(result) {
            const { field, content, type } = result
            this.updatedContent = {
                ...this.listOfFields,
                content: {
                    ...this.listOfFields.content,
                    [field]: {
                        type: type,
                        value: content
                    }
                }
            }
        },
        async updatePage() {
            this.updatedContent = {
                ...this.updatedContent,
                is_active: this.listOfFields.is_active ? 1 : 0,
            }
            try {
                await AdminPanelService.updatePage(this.pageId, this.updatedContent)
                this.$showSuccessMessage('The page was successfully updated!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The page was not updated. Please try again')
            }
        },
        async getPageFields() {
            try {
                const { data: response } = await AdminPanelService.getPageFields(this.pageId)
                this.listOfFields = response
            } catch (e) {
                console.error(e)
            }
        },
        formatLabel(key) {
            return key
                .replace(/_/g, ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
        },
        async uploadImagesForNews(formData) {
            return await AdminPanelService.uploadImagesForNews(formData)
        },
    },
    created() {
        this.getPageFields()
    }

}

</script>


<style scoped>

</style>
